import React from 'react';
import { Svg } from 'assets';
import { RenderWidgetImage, WidgetMeta } from '../constants';

export const DashboardWidgetShell = ({
    icon,
    iconId,
    title,
    onOpen,
    onClose,
    height = 'clamp(240px, 34vh, 460px)',
    toolbar,
    children,
    className = '',
}) => {
    const iconNode = iconId != null ? RenderWidgetImage(iconId, 'badge') : icon;
    const resolvedTitle = title ?? (iconId != null ? WidgetMeta[iconId]?.title : undefined);

    return (
        <div className={`dashboard-widget-shell ${className}`} style={{ height }}>
            <div className="dashboard-widget-shell__header">
                <div className="dashboard-widget-shell__header-left">
                    {iconNode && <div className="dashboard-widget-shell__icon">{iconNode}</div>}
                    <p className="dashboard-widget-shell__title">{resolvedTitle}</p>
                </div>

                <div className="dashboard-widget-shell__actions">
                    <Svg.DragHandleSvg className="dashboard-widget-shell__drag" />
                    {onOpen && (
                        <button type="button" className="dashboard-widget-shell__action" onClick={onOpen} aria-label="Open">
                            <Svg.OpenWidgetSvg />
                        </button>
                    )}

                    {onClose && (
                        <button type="button" className="dashboard-widget-shell__action" onClick={onClose} aria-label="Remove widget">
                            <Svg.CloseGraySvg />
                        </button>
                    )}
                </div>
            </div>

            {toolbar && <div className="dashboard-widget-shell__toolbar">{toolbar}</div>}

            <div className="dashboard-widget-shell__body">
                {children}
            </div>
        </div>
    );
};
